import {articulosConInformacionMinifichaConfirming} from '../../../06-components/articulos-con-informacion-minichicha-confirming';
import {warningAceptarCancelarConfirming} from "../../../06-components/warning-aceptar-cancelar-confirming";

/**
 * Pedido rápido (1 click) para artículos desde la vista de detalle o minificha
 *
 * @param articuloId ID del artículo a pedir en caso de ser un pedido rápido
 * @param codigo Código del artículo a pedir en caso de ser un pedido rápido
 */

function calcularTotalNeto(precio, cantidad, descuento = 0) {
    precio    = parseFloat(precio) || 0;
    cantidad  = parseInt(cantidad, 10) || 0;
    descuento = parseFloat(descuento) || 0;

    return Math.round((precio - (precio * descuento / 100)) * cantidad * 100) / 100;
}

window.getFormulario1ClickArticulo = async function (articuloId, codigo, ean, informacionMinificha, comunidadDiferente, precio = 0, descuentoArticulo = 0) {
    cleanFeedback('storePedido', 'storePedidoFormulario');
    // Variables del modal
    let modalName = 'modalStorePedido'; //modal
    let $btnStore = $(`#${modalName}BotonStore`); //botón de pedido
    // manejo de warnings en el modal
    let $modalWarning         = $(`#${modalName}Warning`); // sección error del modal
    let $modalMessagesWarning = $(`#${modalName}Warning span`); // sección de mensaje de error del modal
    // manejo de errores en el modal
    let $modalError               = $(`#${modalName}Error`); // sección error del modal
    let $modalMessagesError       = $(`#${modalName}Error span`); // sección de mensaje de error del modal
    let articulosParaConfirmacion = [];
    let mostrarConfirming         = false;
    let content                   = '<ul class="text-start">';

    if (informacionMinificha !== '') {
        mostrarConfirming = true;
        content += `<p style="margin: 0"><strong>${transArticulosInfoConfirmar}</strong></p><ul style="margin: 0">`;
        content += `<li>${ean}: ${informacionMinificha}</li>`;
        content += `</ul>`;
    }
    if (comunidadDiferente) {
        mostrarConfirming = true;
        content += `<p style="margin: 0"><strong>${transArticulosConComunidadDiferente}</strong></p><ul style="margin: 0">`;
        content += `<li>${ean}</li>`;
        content += `</ul>`;
    }
    if (mostrarConfirming) {
        content += `</ul>`;
        if (!await warningAceptarCancelarConfirming(content)) {
            return false;
        }
    }
    $('#btn-1-click' + codigo).hide();
    $('#btn-1-click-loading' + codigo).show();
    $('#storePedidoFormulario').hide();
    $btnStore.prop('disabled', true);

    let $btnPedidoRapido = $(`#btn-1-click${codigo}`);
    let articulo,
        cantidad;

    // Comprobamos si la acción se ha realizado desde una minificha o desde la vista de detalle del artículo
    const isMinificha = $btnPedidoRapido.closest(".product-item").length > 0;
    articulo          = $btnPedidoRapido.closest(isMinificha ? ".product-item" : ".product-sidebar");

    cantidad = parseInt(articulo.find('.product-quantity input').val());

    $.ajax({
        url:      `${urlPedido}/crear`,
        type:     "GET",
        dataType: 'json',
        data:     {
            total_neto: calcularTotalNeto(precio, cantidad, descuentoArticulo),
        },
    })
     .done(function (response) {
         $('#btn-1-click-loading' + codigo).hide();
         $('#btn-1-click' + codigo).show();
         $btnStore.attr('onclick', `storeQuickOrder('${articuloId}', '${codigo}', ${cantidad})`);
         // Comprobación de permisos
         if (!response.permiso) {
             $modalMessagesError.html(response.descripcion);
             $modalError.show();
             $btnStore.remove();
             new bootstrap.Modal(document.getElementById("modalStorePedido")).show();
         } else {
             if (response.limite_credito_superado) {
                 $btnStore.prop('disabled', false);
                 $modalMessagesWarning.html(response.descripcion);
                 $modalWarning.show();
                 new bootstrap.Modal(document.getElementById("modalStorePedido")).show();
             } else {
                 storeQuickOrder(articuloId, codigo, cantidad);
             }
         }
         $('#modalStorePedidoContent').show();
         $btnStore.prop('disabled', false);

     })
     .fail(function (errors) {
         let errorMessages = errors.message;
         if (errors.responseJSON) {
             errorMessages = errors.responseJSON.message;
             pNotifyError(errors.responseJSON.message);
         } else if (errors.status >= 500) {
             pNotifyErrorConnection();
         } else {
             pNotifyError(errors.message);
         }
         $('#storePedidoError span').html(errorMessages);
         $('#storePedidoError').show();
         $btnStore.prop('disabled', true);
     });
}

/**
 * Obtiene la información necesaria para mostrar las opciones del formulario de pedido
 *
 * @param urlOrigen Saber si hay que checkear los artículos pedibles de plantilla de pedidos, presupuesto o utilidades de lista
 * @param idOrigen ID de la plantilla de pedidos, presupuesto o lista
 */
window.listaArticulosPedibles = []; // Variable global para almacenar los artículos pedibles
window.idOrigenArticulos   = 0; // Variable global para almacenar el ID de la plantilla, pedido o presupuesto actual
window.getFormulario1click = function (urlOrigen, idOrigen) {
    cleanFeedback('storePedido', 'storePedidoFormulario');
    window.listaArticulosPedibles = [];
    window.idOrigenArticulos      = idOrigen;
    let listaArticulosNoPedibles  = [];
    // Variables del modal
    let modalName                 = 'modalStorePedido'; //modal
    let $btnStore                 = $(`#${modalName}BotonStore`); //botón de pedido
    let $formulario               = $('#storePedidoFormulario'); // formulario de pedido
    let $modalCargando            = $(`#${modalName}Cargando`); // sección de cargando del modal
    let $modalContent             = $(`#${modalName}Content`); // sección de contenido del modal
    // manejo de errores en el modal
    let $modalError         = $(`#${modalName}Error`); // sección error del modal
    let $modalMessagesError = $(`#${modalName}Error span`); // sección de mensaje de error del modal
    let errorMessages       = ''; // Mensajes de error a mostrar
    // manejo de warnings en el modal
    let $modalWarning         = $(`#${modalName}Warning`); // sección error del modal
    let $modalMessagesWarning = $(`#${modalName}Warning span`); // sección de mensaje de error del modal
    let warningMessages       = ''; // mensajes de warning a mostrar

    $modalError.hide(); // ocultamos la sección de error del modal
    $modalWarning.hide(); // ocultamos la sección de warning del modal
    $formulario.hide(); // ocultamos el formulario de pedido
    $btnStore.prop('disabled', true); // deshabilitamos el botón de pedido
    $modalContent.hide(); // ocultamos la sección de contenido del modal
    $modalCargando.show(); // mostramos la sección de cargando del modal

    let modal = new bootstrap.Modal(document.getElementById('modalStorePedido'));
    modal.show(); // mostramos el modal

    $.ajax({
        url:  `${urlPedido}/crear`,
        type: "GET",
    })
     .done(function (response) {
         var bloqueos = response.bloqueos;
         var options  = "<option value=\"\">".concat(ucfirst(transSinBloqueo), "</option>");
         bloqueos.forEach(function (bloqueo) {
             options += "<option value=\"".concat(bloqueo, "\">").concat(bloqueo, "</option>");
         });
         $('#storePedidoCampoExtraInfo_bloqueo').html(options);

         // Solo mostramos el selector de bloqueo si el endpoint ha devuelto bloqueos
         if (bloqueos.length) {
             $('#storePedidoCampoExtraInfo_bloqueoContainer').removeClass('d-none');
         } else {
             $('#storePedidoCampoExtraInfo_bloqueoContainer').addClass('d-none');
         }
         if (!response.permiso) {
             errorMessages += `<p>${response.descripcion}</p>`;
             $modalMessagesError.html(errorMessages);
             $modalError.show();
             $modalCargando.hide();
             $modalContent.show();
         } else {
             const urlCheckArticulos1Click = `${urlOrigen}/${idOrigen}/check-articulos-1-click`;
             $.ajax({
                 url:  urlCheckArticulos1Click,
                 type: "GET",
             })
              .done(function (response) {
                  window.listaArticulosPedibles = response.listaArticulosPedibles;
                  listaArticulosNoPedibles      = response.listaArticulosNoPedibles;
                  const totalNetoArticulosPedibles = response.totalNetoArticulosPedibles || 0;

                  if (window.listaArticulosPedibles.length === 0) { // Si no hay artículos pedibles, muestra un mensaje de error
                      errorMessages += `<p style="margin: 0">${transAlertaSinArticulosPedibles}</p>`;
                      $modalMessagesError.html(errorMessages);
                      $modalError.show();
                      $formulario.hide();
                  } else {
                      if (listaArticulosNoPedibles.length > 0) { // Si hay artículos no pedibles, muestra un warning
                          warningMessages += `<p style="margin: 0">${transAlertaArticulosNoPedibles}</p><ul style="margin: 0">`;
                          warningMessages += listaArticulosNoPedibles.map(articulo => `<li>${articulo.ean}</li>`).join('');
                          warningMessages += `</ul>`;
                          $modalMessagesWarning.html(warningMessages);
                          $modalWarning.show();
                      }
                      // Si hay artículos con información de minificha, muestra un mensaje de warning
                      const articulosConInformacionMinificha = window.listaArticulosPedibles.filter(articulo => articulo.hasOwnProperty('informacionMinificha'));
                      if (articulosConInformacionMinificha.length > 0) {
                          warningMessages += `<p style="margin: 0">${transArticulosInfoConfirmar}</p><ul style="margin: 0">`;
                          warningMessages += articulosConInformacionMinificha.map(articulo => `<li>${articulo.ean}: ${articulo.informacionMinificha}</li>`).join('');
                          warningMessages += `</ul>`;
                          $modalMessagesWarning.html(warningMessages);
                          $modalWarning.show();
                      }
                      // Si hay artículos pertenecientes a una comunidad autónoma diferente a la del usuario, muestra un mensaje de warning
                      const articulosConComunidadDiferente = window.listaArticulosPedibles.filter(articulo => articulo.comunidad_autonoma_diferente === true);
                      if (articulosConComunidadDiferente.length > 0) {
                          warningMessages += `<p style="margin: 0">${transArticulosConComunidadDiferente}</p><ul style="margin: 0">`;
                          warningMessages += articulosConComunidadDiferente.map(articulo => `<li>${articulo.ean}</li>`).join('');
                          warningMessages += `</ul>`;
                          $modalMessagesWarning.html(warningMessages);
                          $modalWarning.show();
                      }
                      $.ajax({
                          url:  `${urlPedido}/crear`,
                          type: "GET",
                          data: {
                              total_neto: totalNetoArticulosPedibles,
                          },
                      })
                       .done(function (response) {
                           if (response.limite_credito_superado) {
                               warningMessages += `<p>${response.descripcion}</p>`;
                               $modalMessagesWarning.html(warningMessages);
                               $modalWarning.show();
                           }
                       })
                       .always(function () {
                           $btnStore.prop('disabled', false);
                           $formulario.show(); // mostramos el formulario de pedido
                       });
                  }
                  $modalCargando.hide();
                  $modalContent.show();
              })
              .fail(function (errors) {
                  let errorText = errors.responseJSON ? errors.responseJSON.message : errors.message;
                  errorMessages += `<p>${errorText}</p>`;
                  $modalMessagesError.html(errorMessages);
                  $modalError.show();
                  $modalCargando.hide();
                  $modalContent.show();
              });
         }
     })
     .fail(function (errors) {
         let errorText = errors.responseJSON ? errors.responseJSON.message : errors.message;
         errorMessages = `<p>${errorText}</p>`;
         $modalMessagesError.html(errorMessages);
         $modalError.show();
         $modalCargando.hide();
         $btnStore.prop('disabled', true);
     });
}

/**
 * Obtener los datos del formulario extra antes de hacer un pedido y lo envía a pedido
 *
 * @returns {Object}
 */
window.getExtraInfo = function () {
    // Datos extra
    cleanFeedback('storePedido', 'storePedidoFormulario');
    // Obtenemos los valores del formulario
    const bloqueo         = $('#storePedidoCampoExtraInfo_bloqueo').val();
    const referencia      = $('#storePedidoCampoExtraInfo_referencia').val();
    const fechaEntrega    = $('#storePedidoCampoExtraInfo_fechaEntrega').val();
    const deposito        = $('#storePedidoCampoExtraInfo_deposito').prop('checked') ? 1 : 0;
    const fechaDeposito   = $('#storePedidoCampoExtraInfo_fechaDeposito').val();
    const materialInterno = $('#storePedidoCampoExtraInfo_materialInterno').prop('checked') ? 1 : 0;
    const envioCompleto   = $('#storePedidoCampoExtraInfo_envioCompleto').prop('checked') ? 1 : 0;
    const enviarConGastos = $('#storePedidoCampoExtraInfo_enviarConGastos').is('select') ? parseInt($('#storePedidoCampoExtraInfo_enviarConGastos').val() || 0) : ($('#storePedidoCampoExtraInfo_enviarConGastos').prop('checked') ? 1 : 0);
    const es_campana      = $('#storePedidoCampoExtraInfo_es_campana').prop('checked') ? 1 : 0;
    const esFeria         = $('.special-fair-campaign-cart').length > 0 ? 1 : 0;

    const data = {
        bloqueo:           bloqueo,
        referencia:        referencia,
        fecha_entrega:     fechaEntrega,
        deposito:          deposito,
        fecha_deposito:    fechaDeposito,
        material_interno:  materialInterno,
        envio_completo:    envioCompleto,
        enviar_con_gastos: enviarConGastos,
        es_campana:        es_campana,
        es_feria:          esFeria,
    };

    // Si el Agente es text se enviaran estos valores al endpoint
    if ($('#storePedidoCampoExtraInfo_tipologiaEnvio').length) {
        data.tipologia_envio = $('#storePedidoCampoExtraInfo_tipologiaEnvio').val();
    }

    // Si existe una campaña especial activa, añadimos los datos necesarios
    const $checkboxesCampanas = $('.checkbox-special-campaing-cart-input:checked');
    if ($checkboxesCampanas.length > 0) {
        data.activar_campana = [];
        data.feria           = {};

        $checkboxesCampanas.each(function () {
            const idCampana = $(this).val();

            // Añadimos las campañas especiales que se han decidido activar
            data.activar_campana.push(idCampana);

            // Añadimos la opción de recogida seleccionada, si existe
            const opcionRecogida = $(`#campanaEspecial${idCampana}OpcionesRecogida .form-check-input:checked`).val();

            if (typeof opcionRecogida !== 'undefined') {
                data.feria[idCampana] = opcionRecogida;
            }
        });
    }

    return data;
}

